module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('a', {
    attrs: {
      "href": "static/impressum.html"
    }
  }, [_vm._v("Impressum")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "static/datenschutz.html"
    }
  }, [_vm._v("Datenschutz")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/sebeichholz/letmesayit",
      "target": "_blank"
    }
  }, [_vm._v("Source Code")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/LetMeSayIt.org/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/_icons/FB-f-Logo__blue_29.png",
      "border": "0",
      "id": "facebook"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bc36556!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 94
// module chunks = 2